import { createTheme } from "@mui/material/styles";

// Define common font families
const fonts = {
  raleway: "'Raleway', sans-serif",
  notoSans: "'Noto Sans', sans-serif",
};

// Define color palette
const colors = {
  light: {
    primary: {
      main: "#440055",
      light: "#6b1983",
      dark: "#2d0038",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#FFCC00",
      light: "#ffd94c",
      dark: "#c29d00",
      contrastText: "#000000",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    text: {
      primary: "#2d0038",
      secondary: "#666666",
    },
  },
  dark: {
    primary: {
      main: "#662277",
      light: "#8844aa",
      dark: "#440055",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ffd633",
      light: "#ffe066",
      dark: "#ccaa00",
      contrastText: "#000000",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b3b3b3",
    },
  },
};

export const createAppTheme = (mode) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light" ? colors.light : colors.dark),
    },
    typography: {
      fontFamily: fonts.notoSans,
      h1: {
        fontFamily: fonts.raleway,
        fontWeight: 600,
      },
      h2: {
        fontFamily: fonts.raleway,
        fontWeight: 600,
      },
      h3: {
        fontFamily: fonts.raleway,
        fontWeight: 600,
      },
      h4: {
        fontFamily: fonts.raleway,
        fontWeight: 500,
      },
      h5: {
        fontFamily: fonts.raleway,
        fontWeight: 500,
      },
      h6: {
        fontFamily: fonts.raleway,
        fontWeight: 500,
      },
      subtitle1: {
        fontFamily: fonts.raleway,
      },
      subtitle2: {
        fontFamily: fonts.raleway,
      },
      body1: {
        fontFamily: fonts.notoSans,
      },
      body2: {
        fontFamily: fonts.notoSans,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          // Font imports moved to index.css to avoid @import rule order issues
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused": {
                backgroundColor:
                  mode === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "rgba(0, 0, 0, 0.03)",
              },
            },
            "& ..MuiInput-input": {
              "&.Mui-focused": {
                backgroundColor:
                  mode === "dark"
                    ? "rgba(255, 255, 255, 0.05)"
                    : "rgba(0, 0, 0, 0.03)",
              },
            },
          },
        },
      },
      ...(mode === "dark" && {
        MuiButton: {
          styleOverrides: {
            outlined: {
              color: "#ffffff",
              borderColor: "#ffffff",
              "&:hover": {
                borderColor: "#ffffff",
                backgroundColor: "rgba(255, 255, 255, 0.08)",
              },
            },
          },
        },
      }),
    },
  });
};
